import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { RarityVaultHowItWorksDialog } from '.';
import type {
  RarityVaultHowItWorksDialogQuery,
  RarityVaultHowItWorksDialogQueryVariables,
} from './__generated__/index.withFetch.graphql';

const query = gql`
  query RarityVaultHowItWorksDialogQuery {
    config {
      id
      sealingConfig {
        ...RarityVaultHowItWorksDialog_sealingConfig
      }
    }
  }
  ${RarityVaultHowItWorksDialog.fragments.sealingConfig}
` as TypedDocumentNode<
  RarityVaultHowItWorksDialogQuery,
  RarityVaultHowItWorksDialogQueryVariables
>;

type Props = {
  open?: boolean;
  onClose: () => void;
};

export const RarityVaultHowItWorksDialogWithFetch = ({
  open = false,
  onClose,
}: Props) => {
  const { data, loading } = useQuery(query, {
    fetchPolicy: 'cache-first',
    skip: !open,
  });

  const sealingConfig = data?.config?.sealingConfig;
  return (
    <RarityVaultHowItWorksDialog
      open={Boolean(open && data)}
      loading={loading}
      onClose={onClose}
      sealingConfig={sealingConfig}
    />
  );
};
